import {
  type PostTen99PolicyApplicationSessionBody,
  type PostTen99PolicyApplicationSessionResponse,
  PostTen99PolicyApplicationSessionResponseSchema,
} from "@clipboard-health/contract-backend-main";
import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";

const CREATE_TEN99_POLICY_APPLICATION_SESSION_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/1099-policy/application-sessions`;

export function useCreateTen99PolicyApplicationSession(
  options: UseMutationOptions<
    PostTen99PolicyApplicationSessionResponse,
    unknown,
    PostTen99PolicyApplicationSessionBody
  > = {}
): UseMutationResult<
  PostTen99PolicyApplicationSessionResponse,
  unknown,
  PostTen99PolicyApplicationSessionBody
> {
  return useMutation({
    mutationKey: [CREATE_TEN99_POLICY_APPLICATION_SESSION_URL],
    mutationFn: async (body: PostTen99PolicyApplicationSessionBody) => {
      const response = await post({
        url: CREATE_TEN99_POLICY_APPLICATION_SESSION_URL,
        data: body,
        responseSchema: PostTen99PolicyApplicationSessionResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_TEN99_POLICY_APPLICATION_SESSION_FAILURE,
    },
    ...options,
  });
}
